import createReducer from '../../../../../common/utils/createReducer.js';
import {sort} from "../actionTypes/sortingTypes";

const initialState = {
  field_name: null,
  direction: null
};

const reducer = {
  [sort.SET_SORTING]: (state, action) => {
    return {
      ...state,
      field_name: action.payload.field_name,
      direction: action.payload.direction
    };
  },

  [sort.RESET_SORTING]: () => {
    return initialState;
  },

  [sort.TOGGLE_SORTING]: (state, action) => {
  const field = action.payload.field_name;

  if (state.field_name !== field) {
    return {
      field_name: field,
      direction: 1
    };
  }

  if (state.direction === 1) {
    return {
      field_name: field,
      direction: -1
    };
  }

  if (state.direction === -1) {
    return {
      field_name: null,
      direction: null
    };
  }

  return {
    field_name: field,
    direction: 1
  };
}

};

export default createReducer(initialState, reducer);
